module.exports = __webpack_public_path__ + "static/Photo1-0053dbe8ffcbadda3ffb1b70492adf09.png";